<app-kontable
  id="dt_calendar"
  [title]="'calendarList.listTitle' | translate"
  [columns]="['id', 'description', 'code', 'time_range',
  { field: 'monday', bodyTemplate: dayValid, title: 'calendarList.monday', filterTemplate: noFilter, filterType: customFilter },
  { field: 'tuesday', bodyTemplate: dayValid, title: 'calendarList.tuesday', filterTemplate: noFilter, filterType: customFilter },
  { field: 'wednesday', bodyTemplate: dayValid, title: 'calendarList.wednesday', filterTemplate: noFilter, filterType: customFilter },
  { field: 'thursday', bodyTemplate: dayValid, title: 'calendarList.thursday', filterTemplate: noFilter, filterType: customFilter },
  { field: 'friday', bodyTemplate: dayValid, title: 'calendarList.friday', filterTemplate: noFilter, filterType: customFilter },
  { field: 'saturday', bodyTemplate: dayValid, title: 'calendarList.saturday', filterTemplate: noFilter, filterType: customFilter },
  { field: 'sunday', bodyTemplate: dayValid, title: 'calendarList.sunday', filterTemplate: noFilter, filterType: customFilter },
  { field: 'flg_extra_open', bodyTemplate: dayValid, title: 'calendarList.extraOpen', filterTemplate: noFilter, filterType: customFilter }
  ]"
  [titles]="['ID', 'calendarList.description', 'calendarList.code', 'calendarList.timeRange', 'calendarList.extraOpen']"
  [source]="calendarItems"
  (onAdd)="showAddOrEditDialog(null)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="delete($event)"
  [(fireNewDataAvailable)]="newDataAvailable"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showInfoButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="true"
>

  <ng-template #dayValid data-testid="dayValid" let-row let-value="value">
    <span *ngIf="value == 1" class="fa fa-check" title="Valid"></span>
    <span *ngIf="value == 0" title="Not Valid">&nbsp;</span>
  </ng-template>

  <ng-template #nofilter data-testid="nofilter" let-row>
  </ng-template>

</app-kontable>

<p-dialog
        [(visible)]="calendarDialog"
        [width]="500"
        header="{{modalTitle}}"
        [minWidth]="500"
        [modal]="true"
        [draggable]="false"
        [resizable]="false">
  <app-calendar-form
    (calendarAdded)="calendarAdded($event)"
    (calendarUpdated)="calendarUpdated($event)"
    *ngIf="calendarDialog"
    [dialogBoxCalendar]="this.srvCalendar.calendarEditing"
  ></app-calendar-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar/calendar.component.html